import React from "react";
import DOMPurify from "isomorphic-dompurify";
interface SectionHeaderProps {
  title: React.ReactNode | string;
  subtitle: string | undefined;
  button?: React.ReactNode;
  dark?: boolean;
  paragraph?: string;
  className?: string;
  direction?: "row" | "column";
  showSubtitle?: boolean;
}

export default function SectionHeader({
  title,
  subtitle,
  button,
  paragraph,
  className = "",
  dark,
  direction = "row",
  showSubtitle = true,
}: SectionHeaderProps) {
  const isColumn = direction === "column";
  return (
    <div
      className={`service-title-header flex flex-col ${isColumn ? "" : "xl:flex-row"}  justify-start gap-[20px] lg:gap-[50px] mt-6 2xl:gap-[50px] items-start w-full ${dark ? "text-white" : "text-black"} ${className}`}
    >
      {showSubtitle && subtitle && (
      <p
        className={`text-start text-[length:var(--primarybtn)] lg:mt-[10px] mt-[0px] font-medium ${isColumn ? "w-full" : "min-w-[13ch] max-w-[20ch]"} uppercase tracking-tight ${dark ? "text-white" : "text-black"}`}
      >
        {subtitle}
      </p>
      )}
      <div
        className={`flex flex-col lg:gap-[20px] gap-[10px] text-[length:var(--section-title)] ${isColumn ? "md:max-w-full" : "lg:max-w-[calc(80%_-_40px)]"}`}
      >
        <h2
          className={` justify-start  font-medium clash-font capitalize leading-[110%] ${dark ? "text-white" : "text-black"}`}
        >
          {title}
        </h2>
        {paragraph && (
          <span
            className={`text-[length:var(--industry-para)] font-normal leading-[150%]  text-start ${dark ? "text-white/70" : "text-black/70"}`}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(paragraph) }}
          />
        )}
      </div>

      <div
        className={`button-container ${isColumn ? "self-end xl:ml-auto" : "xl:ml-auto pb-5 lg:pb-0"}`}
      >
        {button}
      </div>
    </div>
  );
}
